import { ClienteTienda } from "../../bussines/entities/ClienteTienda";

export class ClienteTiendaModel implements ClienteTienda {
    constructor(
        public idCliente: number,
        public razonSocial: string,
        public apPaterno: string,
        public apMaterno: string,
        public nombres: string,
        public docIdentidad: string | null,
        public rucCliente: string | null,
        public otroDocIdentidad: string | null,
        public email: string,
        public domicilio: string | null,
        public obsCliente: string | null,
        public estado: number,
    ) { }

    serialize(): ClienteTienda {
        return {
            idCliente: this.idCliente,
            razonSocial: this.razonSocial,
            apPaterno: this.apPaterno,
            apMaterno: this.apMaterno,
            nombres: this.nombres,
            docIdentidad: this.docIdentidad,
            rucCliente: this.rucCliente,
            otroDocIdentidad: this.otroDocIdentidad,
            email: this.email,
            domicilio: this.domicilio,
            obsCliente: this.obsCliente,
            estado: this.estado,
        }
    }

    static deserialize(entity: ClienteTienda): ClienteTiendaModel {
        return new ClienteTiendaModel(
            entity.idCliente,
            entity.razonSocial ?? '',
            entity.apPaterno ?? '',
            entity.apMaterno ?? '',
            entity.nombres ?? '',
            entity.docIdentidad ?? '',
            entity.rucCliente ?? '',
            entity.otroDocIdentidad ?? '',
            entity.email ?? '',
            entity.domicilio ?? '',
            entity.obsCliente ?? '',
            entity.estado,
        )
    }

}